import { render, staticRenderFns } from "./AiRelationEngine.vue?vue&type=template&id=7de8ab6c&scoped=true"
import script from "./AiRelationEngine.vue?vue&type=script&lang=js"
export * from "./AiRelationEngine.vue?vue&type=script&lang=js"
import style0 from "./AiRelationEngine.vue?vue&type=style&index=0&id=7de8ab6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de8ab6c",
  null
  
)

export default component.exports